import Button from "@material-ui/core/Button";
import { ComboBox } from "../../../components/FormInputs/FormInputs";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function AirportDestination({ ...props }) {
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("destination.label")}</p>
        </div>
        <div className="FormWidth MarginHorizontal">
          <ComboBox
            label={i18n.t("destination.destination")}
            value={props.order.destination}
            onChange={(event, value) => {
              props.handleChange("destination", value);
            }}
          />
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => {
            props.handleBack();
          }}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
        <div className="ButtonContainer">
          <Button
            onClick={() => {
              if (
                (!props.order.delivery && props.order.destination === "") ||
                (!props.order.delivery && props.order.destination === null)
              ) {
                props.handleNext();
              } else if (props.order.delivery) {
                props.handleNext();
              } else if (props.loggedIn) {
                props.handleNext(3);
              } else props.handleNext(2);
            }}
            className="TransparentWhite Medium"
          >
            {i18n.t("general.skip")}
          </Button>
          <Button
            onClick={() => {
              if (
                (!props.order.delivery && props.order.destination === "") ||
                (!props.order.delivery && props.order.destination === null)
              ) {
                props.handleNext();
              } else if (props.order.delivery) {
                props.handleNext();
              } else if (props.loggedIn) {
                props.handleNext(3);
              } else props.handleNext(2);
            }}
            className="OldLace Medium"
          >
            {i18n.t("general.next")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(AirportDestination);
